/* eslint-disable jsx-a11y/anchor-is-valid, jsx-a11y/anchor-has-content */
import { useSelector, useDispatch } from "react-redux";
import { useEffect, useState } from "react";
import Collections from "Components/Collections";
// ------------------------------------------------------
import {
  setJoinFile,
  setJoinFileMatch,
  setJoinCollectionMatch,
  applyJoin,
  removeJoinHeader
} from "Redux/joins/actions";
import { getSamples } from "Redux/files/actions";
import waitbar from "Media/waitbar.gif";

// ------------------------------------------------------
// ------------------------------------------------------
const Joins = () => {

  const [matchData, setMatchData] = useState(null);
  const [samples, setSamples] = useState(null);
  const [collection, setCollection] = useState(null);

  const { current, collections, repository } = useSelector(
    (state) => state.project
  );

  useEffect(() => {
    const collection = collections.find((c) => c.id === current);
    setCollection(collection);
  }, [current, collections]);

  useEffect(() => {
    setSamples(null);
    const collection = collections.find((c) => c.id === current);
    if (collection) {
      const files = collection.fileids.map((fileid) => repository[fileid]);
      getSamples(files, (res) => {
        setSamples(res);
      });
    }
  }, [current, collections, repository]);

  if (!collection) return <Collections />;

  const allFiles = Object.keys(repository).map((fileid) => repository[fileid]);

  const join = collection.join || {};

  return (
    <Collections>
      <Matches data={matchData} />
      <div className="columns">
        <div className="column">
          Collection Headers
          <hr />
          {samples === null ? (
            <div>
              <img src={waitbar} alt="Loading" />
            </div>
          ) : (
            <div className="tags">
              {samples.headers.map((header) => {
                return (
                  <>
                    <div
                      className="tag v-margin-5 is-primary is-light is-draggable"
                      draggable
                      onDragStart={(evt) => {
                        evt.dataTransfer.setData("collectionheader", header);
                      }}
                      key={header}
                    >
                      {header}
                    </div>
                  </>
                );
              })}
            </div>
          )}
        </div>
        <div className="column is-one-third">
          <Join
            join={join}
            collectionid={collection.id}
            setData={setMatchData}
          />
        </div>
        <div className="column">
          Project Files
          <hr />
          <div className="tags">
            {allFiles.map((file) => {
              const shortened =
                file.name.length > 35
                  ? file.name.substring(0, 35) + "..."
                  : file.name;
              return (
                <div
                  draggable
                  onDragStart={(evt) => {
                    evt.dataTransfer.setData("fileid", file.id);
                  }}
                  className="is-draggable tag is-info is-light v-margin-5"
                >
                  {shortened}
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </Collections>
  );
};

export default Joins;

// ------------------------------------------------------
// ------------------------------------------------------
const Join = ({ join, collectionid, setData }) => {
  const dispatch = useDispatch();
  const [joining, setJoining] = useState(false);
  const { repository } = useSelector((state) => state.project);

  if (!join.file)
    return (
      <div
        className="new-join"
        onDragOver={(evt) => {
          evt.preventDefault();
        }}
        onDrop={(evt) => {
          const fileid = evt.dataTransfer.getData("fileid");

          dispatch(
            setJoinFile(collectionid, repository[fileid], (res) => {
              console.log("Join File is", res);
            })
          );
        }}
      >
        <i className="fa-duotone fa-link-simple" />
      </div>
    );

  const shortened =
    join.file.name.length > 35
      ? join.file.name.substring(0, 35) + "..."
      : join.file.name;

  const headers = [...join.headers].filter((header) => header !== join.fileMatch);
  const isActive = join.collectionMatch && join.fileMatch && join.file;
  return (
    <div className={`join-container ${isActive ? "active" : ""}`}>
      <div
        style={{
          display: "flex",
          flexDirection: "row",
          justifyContent: "space-between",
          alignItems: "flex-start",
          marginBottom: 10,
        }}
      >
        <div
          style={{
            flex: 3,
            backgroundColor: "#efefef",
            borderRadius: 8,
            padding: "3px 18px",
            marginRight: 2,
            textAlign: "center",
          }}
        >
          <div
            className={`placeholder ${join.collectionMatch ? "active" : ""}`}
            onDragOver={(evt) => evt.preventDefault()}
            onDrop={(evt) => {
              const header = evt.dataTransfer.getData("collectionheader");
              dispatch(setJoinCollectionMatch(collectionid, header));
              console.log("Header is", header);
            }}
          >
            {join.collectionMatch ? (
              <span className="tag is-primary">{join.collectionMatch}</span>
            ) : (
              ""
            )}
          </div>
        </div>
        <div
          style={{
            flex: 3,
            marginLeft: 2,
            backgroundColor: "#efefef",
            borderRadius: 8,
            padding: "3px 18px",
            minHeight: 50,
          }}
        >
          <div
            className={`placeholder ${join.fileMatch ? "active" : ""}`}
            onDragOver={(evt) => evt.preventDefault()}
            onDrop={(evt) => {
              const header = evt.dataTransfer.getData("header");
              dispatch(setJoinFileMatch(collectionid, header));
            }}
          >
            {join.fileMatch ? (
              <span className="tag is-info">{join.fileMatch}</span>
            ) : (
              ""
            )}
          </div>
        </div>
      </div>
      <div
        style={{
          minHeight: 100,
          backgroundColor: "#efefef",
          borderRadius: 8,
          marginTop: -17,
        }}
      >
        <div style={{ margin: 10 }}>
          <div className="field is-grouped is-grouped-multiline">
            {headers.map((header, headerindex) => (
              <div
                className="control is-draggable"
                key={`join-headers-${header}`}
                draggable
                onDragStart={(evt) => {
                  evt.dataTransfer.setData("header", header);
                }}
              >
                <div className="tags has-addons">
                  <div className="tag is-warning is-light">{header}</div>
                  <a role="button" tabIndex={0} className="tag is-warning is-delete is-light" aria-label="Delete"
                    onClick = { () => {
                      dispatch(removeJoinHeader(collectionid, header));
                    }}
                  ></a>
                </div>
              </div>
            ))}
          </div>
          <hr style = {{ margin: 5 }}/>
          <div className="tag has-addons">
            <div className="tag is-info is-light">{shortened}</div>
            <div className="tag is-warning is-delete is-light" onClick = {
              () => {
                dispatch({type: "RESET_JOIN", collectionid})
            }}></div>
          </div>
          <hr style = {{ margin: "5px 0 10px 0" }}/>
          <button className = {`button is-small ${joining ? "is-loading" : ""}`} onClick = {
            () => {
              setJoining(true);
              dispatch(applyJoin(collectionid, join, (data) => {
                setData(data);
                setJoining(false);
              }))
            }
          }>
            <span className="icon is-small">
              <i className="fa-duotone fa-link-simple" />
            </span>
            <span>Apply</span>
          </button>

        </div>
      </div>
    </div>
  );
};


// ------------------------------------------------------
// ------------------------------------------------------
const Matches = ({ data }) => {
  const [active, setActive] = useState("direct");

  if(!data) return null;

  return (
    <div className="modal is-active">
      <div className="modal-background"></div>
      <div className="modal-card">
        <header className="modal-card-head">
          <div className="tabs">
            <ul>
              <li className={active === "direct" ? "is-active" : ""}>
                <a role="button" tabIndex={0} onClick={() => setActive("direct")}>
                  Full Match ({data.direct.length})
                </a>
              </li>
              <li className={active === "similar" ? "is-active" : ""}>
                <a role="button" tabIndex={0} onClick={() => setActive("similar")}>
                  Similar ({data.similar.length})
                </a>
              </li>
              <li className={active === "none" ? "is-active" : ""}>
                <a role="button" tabIndex={0} onClick={() => setActive("none")}>
                  No Match ({data.noMatch.length})
                </a>
              </li>
            </ul>
          </div>
        </header>
        <section className="modal-card-body">
          <table className="table is-fullwidth is-striped">
            <thead>
              <tr>
                <th>Cluster</th>
                <th>Linked File</th>
                <th>Distance</th>
              </tr>
            </thead>
            <tbody>
              {active === "direct"
                ? data.direct.map((row, directindex) => (
                    <tr key={`direct-${directindex}`}>
                      <td>{row.input}</td>
                      <td>{row.linkage.toUpperCase()}</td>
                      <td>0</td>
                    </tr>
                  ))
                : null}
              {active === "similar"
                ? data.similar.map((row, similarindex) => (
                    <tr key={`similar-${similarindex}`}>
                      <td>{row.input}</td>
                      <td>{row.linkage}</td>
                      <td>{row.distance}</td>
                    </tr>
                  ))
                : null}
              {active === "none"
                ? data.noMatch.map((row, noindex) => (
                    <tr key={`none-${noindex}`}>
                      <td>{row.input}</td>
                      <td>{row.linkage}</td>
                      <td>{row.bestDistance}</td>
                    </tr>
                  ))
                : null}
            </tbody>
          </table>
        </section>
        <footer className="modal-card-foot"></footer>
      </div>
    </div>
  );
}